import React from 'react';

export default function LoadingSpinner({ message = "Loading...", description }) {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <img 
        src="/logo192.png" 
        alt="Loading" 
        style={{ 
          width: '64px', 
          height: '64px', 
          animation: 'spin 2s linear infinite',
          marginBottom: '20px'
        }} 
      />
      <h2>{message}</h2>
      {description && <p>{description}</p>}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}